//settings
import React from 'react';

//routes
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

//styles
import "./structure_styles/app.module.scss";

//Components
import HeaderComponent from './components/header/Header';
import FooterComponent from './components/footer/Footer';

//views
import HomeView from './views/home/Home';
import ExperienceView from './views/experience/Expecience';
import PortfolioView from './views/portfolio/Portfolio';
import SkillsView from './views/skills/Skills';
import AcademicView from './views/academic/Academic';

const App: React.FC = () => {
	const renderView = (component: any) => {
		return (
			<>
                <HeaderComponent />
                <div className={[].join(' ')}>
                    {component}
                </div>
				<FooterComponent />
			</>
		);
	};

	return (
		<Router>
			<Routes>
				<Route path="/experience" element={renderView(<ExperienceView />)} />
				<Route path="/portfolio" element={renderView(<PortfolioView />)} />
				<Route path="/skills" element={renderView(<SkillsView />)} />
				<Route path="/academic" element={renderView(<AcademicView />)} />
				<Route path="/" element={renderView(<HomeView />)} />
			</Routes>
		</Router>
	);
}

export default App;